<template lang="pug">
    div(id="app")
        router-view
</template>

<script>
export default {
    name: "app",
    data() {
        return {};
    }
};
</script>

<style lang="stylus">
html, body
    height 100%
    padding 0
    margin 0

#app
    height 100%
</style>
